export default "__VITE_ASSET__YjMy2qgg__"